import { Link } from 'react-router-dom';

export default function ReturnMechanism() {
  const mechanisms = [
    {
      icon: 'ri-percent-line',
      title: '基本還元率',
      description: 'カード利用額に対して常に付与されるポイント還元率。例えば還元率1%なら、100円利用で1円相当のポイントが貯まります。',
      example: '100円利用 → 1ポイント（1円相当）'
    },
    {
      icon: 'ri-store-3-line',
      title: '特約店還元',
      description: 'カード会社が提携している特定の店舗やサービスで利用すると、基本還元率に加えて追加ポイントが付与されます。',
      example: 'コンビニで7%還元 → 100円で7円相当'
    },
    {
      icon: 'ri-shopping-cart-line',
      title: 'ネットショッピング還元',
      description: 'カード会社の専用モールを経由してネットショッピングをすると、通常より高い還元率でポイントが貯まります。',
      example: 'ECモールで3%以上 → 10,000円で300円以上'
    },
    {
      icon: 'ri-calendar-event-line',
      title: 'キャンペーン還元',
      description: '期間限定のキャンペーンに参加すると、通常よりも高い還元率でポイントが付与されることがあります。',
      example: '新規入会で5,000ポイントプレゼント'
    }
  ];

  const calculations = [
    {
      card: '三井住友カード（NL）',
      scenario: 'コンビニで月3万円利用',
      calculation: '30,000円 × 7% = 2,100円相当',
      annual: '年間25,200円相当のポイント'
    },
    {
      card: '大手ECモール系カード',
      scenario: 'ECモールで月5万円利用',
      calculation: '50,000円 × 3% = 1,500円相当',
      annual: '年間18,000円相当のポイント'
    },
    {
      card: 'リクルートカード',
      scenario: '日常生活で月10万円利用',
      calculation: '100,000円 × 1.2% = 1,200円相当',
      annual: '年間14,400円相当のポイント'
    }
  ];

  return (
    <>
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              還元率の仕組み
            </h2>
            <p className="text-lg text-gray-600">
              ポイント還元の仕組みを理解して、賢くポイントを貯めましょう
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-16">
            {mechanisms.map((item, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 border border-gray-200 hover:shadow-lg transition-all"
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#FFB800]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-[#FFB800] text-2xl`}></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                    <p className="text-gray-600 mb-3 leading-relaxed">{item.description}</p>
                    <div className="bg-[#FFB800]/5 border border-[#FFB800]/20 rounded-lg p-3">
                      <div className="text-sm font-medium text-[#FFB800]">例：{item.example}</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-gradient-to-br from-[#FFB800]/5 to-[#FFA000]/5 rounded-xl p-8 border border-[#FFB800]/20">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
              実際の還元額シミュレーション
            </h3>
            <div className="space-y-6">
              {calculations.map((calc, index) => (
                <div
                  key={index}
                  className="bg-white rounded-lg p-6 shadow-sm border border-gray-200"
                >
                  <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                    <div className="flex-1">
                      <div className="text-lg font-bold text-gray-900 mb-2">{calc.card}</div>
                      <div className="text-sm text-gray-600 mb-2">{calc.scenario}</div>
                      <div className="text-sm text-gray-700 font-medium">{calc.calculation}</div>
                    </div>
                    <div className="flex-shrink-0">
                      <div className="bg-gradient-to-br from-[#FFB800] to-[#FFA000] text-white px-6 py-3 rounded-lg text-center">
                        <div className="text-xs mb-1">年間還元額</div>
                        <div className="text-xl font-bold">{calc.annual}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-6 text-center text-sm text-gray-600">
              ※ 還元率は利用店舗や条件により異なります。最新情報は各カード会社の公式サイトでご確認ください。
            </div>
          </div>
        </div>
      </section>

      {/* 3️⃣ 記事途中にCTA追加 */}
      <section className="py-12 bg-gradient-to-b from-white to-[#FFB800]/5">
        <div className="max-w-4xl mx-auto px-4">
          <div className="bg-gradient-to-r from-[#FFB800] to-[#FFA000] rounded-2xl p-8 text-white shadow-xl">
            <div className="flex items-center gap-2 mb-4">
              <div className="px-3 py-1 bg-white text-[#FFB800] text-xs font-bold rounded-full whitespace-nowrap">
                人気No.1
              </div>
              <div className="px-3 py-1 bg-red-500 text-white text-xs font-bold rounded-full whitespace-nowrap">
                最大7%還元
              </div>
            </div>
            
            <h3 className="text-2xl font-bold mb-4">三井住友カード（NL）</h3>
            
            <p className="text-lg mb-6 opacity-95">
              対象のコンビニ・飲食店で最大7%還元。年会費永年無料で維持コスト0円。最短10秒でカード番号発行ですぐに使えます。
            </p>
            
            <div className="flex flex-col sm:flex-row gap-3">
              <Link 
                to="/mitsui"
                className="flex-1 px-6 py-4 bg-white text-[#FFB800] text-center rounded-lg hover:bg-gray-50 transition-colors font-bold text-lg whitespace-nowrap cursor-pointer"
              >
                詳細ページを見る
              </Link>
              <a 
                href="#apply"
                className="flex-1 px-6 py-4 bg-gray-900 text-white text-center rounded-lg hover:bg-gray-800 transition-colors font-bold text-lg whitespace-nowrap cursor-pointer"
              >
                公式サイトはこちら
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
